<template>
    <div v-if="showPopup" ref="labelSearchPopup" class="label-search-popup" :style="{ '--right-offset': rightOffset + 'px' }">
        <div class="header">
            <section class="header__content">
                <h5 class="title">
                    Buscar termo clínico
                </h5>
                <p class="description">
                    Digite no campo abaixo para encontrar um termo clínico.
                </p>
            </section>
            <span class="header__close" @click="closeSearchPopup">
                <CloseSvgIcon />
            </span>
        </div>
        <div class="content">
            <section class="content__search">
                <SearchSvgIcon class="icon" />
                <input class="input" ref="inputElementRef" @keydown="onKeyDown" type="text" v-model="searchText"
                    placeholder="Ex: ateroma, implante, lesão" />
            </section>
            <div class="content__info">
                <span class="counter">
                    {{ resultsCount.search }} de {{ resultsCount.total }} termos
                </span>

                <span class="help">
                    Pressione
                    <Kbd text="↵" />
                    para selecionar
                </span>
            </div>
            <div class="content__results">
                <labelAutocompleteList :filterReportNodes="false" :searchText="searchText" :filterLayerId="null" :cursorActive="true"
                    @select="selectNode" @onTotalResultsChange="onTotalResultsChange" />

                <p class="empty" v-if="resultsCount.search === 0 && resultsCount.total > 0">Nenhum resultado encontrado</p>
            </div>
        </div>
    </div>
</template>

<script>
import { evtBus } from '@/main';
import labelAutocompleteList from './autocomplete/labelAutocompleteList.vue';
import { mapActions } from 'vuex';
import { gConsts } from '@/globals/gConsts';
import Kbd from '@/components/ui/text/kbd.vue';

import SearchSvgIcon from '@/assets/icons/search.svg';
import CloseSvgIcon from '@/assets/icons/close.svg';

export default {
    name: 'labelSearchPopup',
    components: {
        labelAutocompleteList,
        CloseSvgIcon,
        SearchSvgIcon,
        Kbd
    },
    props: {
        rightOffset: {
            type: Number,
            default: 0,
        },
    },

    data() {
        return {
            searchText: '',
            resultsCount: {
                search: 0,
                total: 0,
            },
            showPopup: false,
        }
    },

    watch: {
    },

    methods: {
        ...mapActions([
            'ACT_reportNodes_addNewLabelReportText',
        ]),

        selectNode(node) {
            // console.log('selectNode', nodes);
            this.searchText = '';
            evtBus.$emit('evt_relatorioDinamico_activateNode', { nodeId: node.id, nodeType: gConsts.node.layout.types.LABEL });
            this.ACT_reportNodes_addNewLabelReportText({ labelId: node.id });
            this.$refs.inputElementRef.blur();
            this.closeSearchPopup();
        },

        onKeyDown(event) {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                evtBus.$emit('evt_labelAutocomplete_action', 'cursorMove', { direction: 'next' });
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                evtBus.$emit('evt_labelAutocomplete_action', 'cursorMove', { direction: 'previous' });
            } else if (event.key === 'Enter') {
                event.preventDefault();
                evtBus.$emit('evt_labelAutocomplete_action', 'cursorSelectTerm');
            } else if (event.key === 'Escape') {
                event.preventDefault();
                if (this.searchText.length > 0) {
                    this.searchText = '';
                } else {
                    this.closeSearchPopup();
                }
            }
        },

        closeSearchPopup() {
            this.showPopup = false;
            this.searchText = '';
            this.resultsCount = {
                search: 0,
                total: 0,
            };
            evtBus.$emit('evt_labelSearchPopup_onClose');
        },

        onTotalResultsChange(resultsCount) {
            this.resultsCount = resultsCount;
        },

        onSearchActionEvent(searchTerm) {
            this.showPopup = true;
            this.$nextTick(() => {
                // this.searchText = searchTerm;
                if (this.$refs.inputElementRef) {
                    this.$refs.inputElementRef.focus();
                }
            });
        },

    },

    mounted() {

        evtBus.$on('evt_labelSearchAction', (source, payload) => {
            if (source !== 'relatorio') {
                this.onSearchActionEvent(payload.searchTerm ?? '');
            }
        });

        evtBus.$on('evt_labelSearchPopup_close', () => {
            this.closeSearchPopup();
        });
    }
}
</script>

<style scoped>
.label-search-popup {
    position: absolute;
    top: 100px;
    right: calc(80px + var(--right-offset, 0px));
    z-index: 1000;
    background: white;
    border: 1px solid var(--border-primary);
    border-radius: var(--radius-lg);
    box-shadow: 0 2px 8px #00000066;
    width: 400px;
    overflow: hidden;
    margin-top: var(--spacing-xs);
    animation: fadeIn 0.3s ease-in-out;
}

.label-search-popup>.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--spacing-md);
    text-align: left;
    background-color: var(--background-gray);
    border-bottom: 1px solid var(--border-primary);
}

.label-search-popup .header__content {
    display: flex;
    flex-direction: column;
}

.label-search-popup .header__content .title {
    margin: 0;
    font-size: var(--text-sm);
    font-weight: 700;
    color: var(--color-black);
}

.label-search-popup .header__content .description {
    margin: 0;
    font-size: var(--text-xs);
    font-weight: 400;
    color: var(--color-dark-gray);
}

.label-search-popup .header__close {
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: flex-start;
    padding: var(--spacing-sm);
    color: var(--color-dark-gray);
    border: 1px solid var(--border-primary);
    border-radius: var(--radius-md);
    cursor: pointer;
    transition: all 0.2s ease;
}

.label-search-popup .header__close:hover {
    background-color: var(--background-light-gray);
}

.label-search-popup .header__close:active {
    scale: 0.98;
}

.label-search-popup .header__close>svg {
    width: 14px;
    height: 14px;
}

.label-search-popup>.content {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xs);
    padding: var(--spacing-md);
    box-sizing: border-box;
}

.label-search-popup .content__search {
    display: flex;
    align-items: center;
    width: 100%;
    gap: var(--spacing-sm);
    padding: 10px var(--spacing-md);
    border: 1px solid var(--border-primary);
    border-radius: var(--radius-lg);
    background-color: var(--background-white);
    box-sizing: border-box;
}

.label-search-popup .content__search>.icon {
    width: 16px;
    height: 16px;
    color: var(--color-dark-gray);
    flex-shrink: 0;
}

.label-search-popup .content__search>.input {
    width: 100%;
    flex: 1;
    padding: 0;
    margin: 0;
    border: none;
    outline: none;
    font-size: var(--text-sm);
    font-weight: 400;
}

.label-search-popup .content__search>.input::placeholder {
    color: var(--placeholder-color);
    font-weight: 400;
}

.label-search-popup .content__info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: var(--spacing-xs);
    box-sizing: border-box;
}

.label-search-popup .content__info>.counter, .label-search-popup .content__info>.help {
    font-size: var(--text-xs);
    font-weight: 600;
    text-align: left;
    color: var(--color-dark-gray);
}

.label-search-popup .content__info>.help {
    opacity: 0.8;
}


.label-search-popup .content__results {
    width: 100%;
    padding: var(--spacing-xs);
    margin-top: var(--spacing-xs);
}

.label-search-popup .content__results> .empty {
    margin: 0;
    padding: var(--spacing-xs) 0;
    font-size: var(--text-sm);
    font-weight: 500;
    color: var(--color-dark-gray);
    text-align: center;
}
</style>
